<template>
  <span v-loading="isLoadingFile">
    <input
      type="file"
      ref="filesContainer"
      accept="application/pdf, image/*, .zip"
      style="display:none"
      multiple
      @change="handleFiles"
    >
    <a
      href=""
      class="btn btn-fill"
      @click.prevent="$refs.filesContainer.click()"
    >Selecionar Arquivos</a>
    <span v-for="selectedFile in selectedFiles" :key="selectedFile">
      {{ selectedFile }}
    </span>
  </span>
</template>
<script>
import {filesService} from '../../services'

export default {
  name: 'upload-term-lamps',

  data () {
    return {
      selectedFiles: [],
      isLoadingFile: false
    }
  },

  methods: {
    async handleFiles (data) {
      let files = data.target.files
      Array.prototype.forEach.call(files, async file => {
        this.selectedFiles.push(file.name)

        const loadedFile = await filesService.loadFile(file)

        const blob = new Blob([loadedFile], {type: file.type})
        this.$emit('update-file', {
          name: file.name,
          blob
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Lamps/UploadTermLamps.vue